import Vue from 'vue'
import VueResource from 'vue-resource'
import App from './App'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import 'vue2-animate/dist/vue2-animate.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import './assets/css/style.css'
import { sync } from 'vuex-router-sync'
import store from './vuex/store'
import { mapGetters } from 'vuex'
import VueMoment from 'vue-moment'
import moment from 'moment'

Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(VueResource)
Vue.use(VueMoment)

moment.locale('nl')

sync(store, router)

Vue.http.interceptors.push(function (request, next) {
  request.withCredentials = true

  next()
})

/* Logging is disabled for now
if (window.navigator.userAgent.match(/ TC7[05]x? /)) {
  EB.Log.destinationURI = process.env.API_URL + '/zebra/log'
  EB.Log.destination = [EB.Log.DEST_FILE, EB.Log.DEST_URI]
  EB.Log.level = EB.Log.LEVEL_TRACE
  EB.Log.excludeCategories = ''
  EB.Log.netTrace = false
  EB.Log.skipPost = true

  EB.Log.cleanLogFile()

  let sendLogFile = () => {
    EB.Log.sendLogFile(() => {
      setTimeout(() => {
        sendLogFile()
      }, 1000)
    })
  }

  sendLogFile()
} */

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  computed: {
    ...mapGetters('loading', [
      'isLoading',
      'anyLoading'
    ])
  },
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js